import { GenericObject } from "utility/misc";

import m365Config from "./config";

// -----------------------------------------------------------------------------

export default function redirectToM365OauthUrl(
  orgStore: GenericObject,
  navigate: Function
): void {
  const params = new URLSearchParams({
    client_id: m365Config.clientID ?? "",
    prompt: "admin_consent",
    response_type: "code",
    resource: "https://manage.office.com",
    redirect_uri: encodeURI(
      `${window.location.origin}/environment/sources/m365/oauth2`
    ),
    state: orgStore.uuid,
  }).toString();
  const oauthURL = `https://login.windows.net/common/oauth2/authorize?${params}`;

  window.location.href = oauthURL;
}
